import { GMXPanel } from './panel'
import { GMXLocationSingleton } from '../singletons/location-singleton'

export class GMXGeoIPCountryConfirmationPanel extends GMXPanel {
	panelCountrySelectorDropdown: HTMLSelectElement
	panelConfirmBtn: HTMLButtonElement

	private boundHandleConfirmBtnClick = this._handleConfirmBtnClick.bind(this)

	async connectedCallback(): Promise<void> {
		await super.connectedCallback()

		this.panelCountrySelectorDropdown = this.querySelector('#gmx-geoip-country-dropdown') as HTMLSelectElement
		this.panelConfirmBtn = this.querySelector('[data-geoip-confirm-btn]') as HTMLButtonElement

		this.panelConfirmBtn?.addEventListener('click', this.boundHandleConfirmBtnClick)
	}

	disconnectedCallback() {
		super.disconnectedCallback()

		this.panelConfirmBtn?.removeEventListener('click', this.boundHandleConfirmBtnClick)
	}

	private _handleConfirmBtnClick(): void {
		GMXLocationSingleton.setGeoIpSession(true)

		const selectedOption = this.panelCountrySelectorDropdown?.selectedOptions[0]
		if (selectedOption) {
			const siteUrl = selectedOption.getAttribute('data-site-url')
			if (siteUrl) {
				try {
					const parsedUrl = new URL(siteUrl, window.location.origin)
					if (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:') {
						window.location.href = parsedUrl.toString()
					}
				} catch {
					// Ignore invalid URL values from DOM attributes.
				}
			}
		}

		this.hidePanel()
	}

	/**
	 * @override
	 */
	handleCloseBtnClick(): void {
		super.handleCloseBtnClick()

		GMXLocationSingleton.setGeoIpSession(true)
	}

	/**
	 * @override
	 */
	handleComponentClick(e: Event): void {
		super.handleComponentClick(e)

		const target = e.target as HTMLElement
		if (!target.classList.contains('panel-container') && !target.closest('.panel-container')) {
			GMXLocationSingleton.setGeoIpSession(true)
		}
	}
}
if (!customElements.get('gmx-geoip-country-confirmation-panel')) {
	customElements.define('gmx-geoip-country-confirmation-panel', GMXGeoIPCountryConfirmationPanel)
}
